export default "__VITE_ASSET__DMfKCXGS__"